import { render, staticRenderFns } from "./InactiveAssetsCatalogTable.vue?vue&type=template&id=e7ffc3d8"
import script from "./InactiveAssetsCatalogTable.vue?vue&type=script&lang=js"
export * from "./InactiveAssetsCatalogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports